export default "__VITE_ASSET__CHyba7NW__"